import type { ReactNode } from 'react';
import { BottomBar, Sidebar } from './Nav';
import { LanguageSwitcher } from './LanguageSwitcher';
import { useI18n } from '../../i18n';

/** App chrome for authed surfaces: sidebar (desktop) + top bar + bottom bar (mobile). */
export function AppShell({ children }: { children: ReactNode }) {
  const { t } = useI18n();
  return (
    <div className="flex min-h-dvh bg-bg">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex h-14 items-center justify-between border-b border-border-strong px-4 lg:hidden">
          <span className="type-heading-2 text-primary">{t.common.brand}</span>
          <LanguageSwitcher />
        </header>
        <main className="mx-auto w-full max-w-content flex-1 px-4 pb-24 pt-4 sm:px-6 lg:px-8 lg:pb-8">
          {children}
        </main>
      </div>
      <BottomBar />
    </div>
  );
}

/** Page header block: title + optional subtitle + optional right slot. */
export function PageHeader({ title, subtitle, right }: { title: string; subtitle?: string; right?: ReactNode }) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h1 className="type-display-lg text-primary">{title}</h1>
        {subtitle ? <p className="type-body text-secondary mt-1">{subtitle}</p> : null}
      </div>
      {right}
    </div>
  );
}
